import React, { useState } from "react";
import AddNewItem from "../../../../../../../components/modals/AddNewItem";
import IntegrationForm from "../components/IntegrationForm";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import IntegrationsService from "../../../../../../../../services/IntegrationsService";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../../../../redux/actions/ui";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import SaveIcon from "@material-ui/icons/Save";

const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
}));

function AddnewIntegration(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit, control, setError, getValues, watch } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });
   
  const creteNewIntegration = async data => {    
    setIsLoadingSubmit(true);     
    setIsEditableForm(false);
    try{      
      data.integration_type = "LMS";
      await IntegrationsService.createIntegration(data);
      setIsLoadingSubmit(false);      
      setIsEditableForm(true);
      dispatch(showSnackBar("Successfully edited!"));      
      // We updated the list
      props.updateIntegrationFromList();
      props.onClose(false);      
    }catch (error) {
      setIsLoadingSubmit(false);

      console.log(error);
      let errorMsg = 'An error occurred!';
      let typeError = 'error';
      if(error && error.response && error.response.data && error.response.data.non_field_errors){
        errorMsg = error.response.data.non_field_errors[0];
      }
      dispatch(showSnackBar(errorMsg, typeError));
      const errorData = error.response ? error.response.data : {};
      if (typeof errorData == "object") {
        for (let [key, value] of Object.entries(errorData)) {
          setError(key, "notMatch", value);          
        }             
      } 

      // dispatch(showSnackBar("An error occurred!: " + error, 'error'));
      setIsEditableForm(true);
    }  
  };

  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit}           
          onClick={handleSubmit(creteNewIntegration)}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          Save
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit} actions={actions} >
      <IntegrationForm isEditableForm={isEditableForm} onSubmit={creteNewIntegration} formConfig={ {register, errors, handleSubmit, control, getValues, watch} }/>
    </AddNewItem>
  )
}

export default AddnewIntegration;